// extracted by mini-css-extract-plugin
export var container = "forum-module--container--wDzBK";
export var content = "forum-module--content--eJuU5";
export var list = "forum-module--list--FmKHO";
export var listBox = "forum-module--list-box--P2b1P";
export var listTitle = "forum-module--list-title--DJxpa";
export var loader = "forum-module--loader--L0tYv";
export var message = "forum-module--message--Vxzwf";